export default class Comodidade {
  id_comodidade: number;
  nome: string;
}
